import { render, staticRenderFns } from "./c_checked_tab.vue?vue&type=template&id=4029d5d6&scoped=true"
import script from "./c_checked_tab.vue?vue&type=script&lang=js"
export * from "./c_checked_tab.vue?vue&type=script&lang=js"
import style0 from "./c_checked_tab.vue?vue&type=style&index=0&id=4029d5d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029d5d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4029d5d6')) {
      api.createRecord('4029d5d6', component.options)
    } else {
      api.reload('4029d5d6', component.options)
    }
    module.hot.accept("./c_checked_tab.vue?vue&type=template&id=4029d5d6&scoped=true", function () {
      api.rerender('4029d5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_checked_tab.vue"
export default component.exports